export default __webpack_public_path__ + "static/media/wallet-dweb-109afcf439ce0ed61dc8b5554e714314.png";